module.exports = KsysAppTemplateV2dot58dot0;